import type { IResponseUser, IAppUser } from '../../API/user'
import type { PayloadAction } from '@reduxjs/toolkit'

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import { UserApi } from '../../API/user'

export interface IApp {
  isReady: boolean
  user: IAppUser

  commit: {
    ref: string | null
    date: string | null
  }
}

export const fetchUserInfo = createAsyncThunk(
  'userInfo/fetchUserInfo',
  async (_obj, { rejectWithValue }) => {
    const response: IResponseUser = await UserApi.getUserInformation()
    if (response.status === 200 && response.data !== undefined) {
      return response.data
    }
    if (response.status === 401) {
      localStorage.removeItem('token')
      return rejectWithValue(`${response.status} Error`)
    }
  }
)

const initialState: IApp = {
  isReady: false,
  user: {
    first_name: '',
    last_name: '',
    email: '',
    permissions: [],
    inheritance: [],
    roles: []
  },

  commit: {
    ref: null,
    date: null
  }
}

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setCommit(state, action: PayloadAction<IApp['commit']>) {
      state.commit = action.payload
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchUserInfo.fulfilled, (state, action) => {
      state.user.email = action.payload === undefined ? '' : action.payload.email
      state.user.first_name = action.payload === undefined ? '' : action.payload.first_name
      state.user.last_name = action.payload === undefined ? '' : action.payload.last_name
      state.user.permissions = action.payload === undefined ? [] : action.payload.permissions
      state.user.inheritance = action.payload === undefined ? [] : action.payload.inheritance
      state.user.roles = action.payload === undefined ? [] : action.payload.roles

      state.isReady = true
    })
    builder.addCase(fetchUserInfo.rejected, (state, _action) => {
      state.isReady = true
    })
  }
})
export const { setCommit } = appSlice.actions
export default appSlice.reducer
